<template>
  <div style="padding: 30px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="运费金额">
            <el-input v-model="row.deliveryFeeDeserved" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="托运人已付金额">
            <el-input v-model="row.allotTaxAmount" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已预付油点">
            <el-input v-model="row.payOil" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已预付现金">
            <el-input v-model="row.payAmount" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="预付现金" prop="cash">
            <el-input
              v-model="form.cash"
              :disabled="cashdisabled"
              step="0.01"
              placeholder="请输入预付现金"
              @input="
                value => formFormatter.isFloor2(value, oldValue, form, 'cash')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="获取验证码" prop="mybankBalancePayDTO.smsCode">
            <el-input
              v-model="form.mybankBalancePayDTO.smsCode"
              maxlength="20"
              placeholder="请输入验证码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple-light">
            <!-- <span v-show="show" @click="getCode" class="smscode">获取验证码</span> -->
            <el-button
              v-show="show"
              type="primary"
              round
              size="small"
              @click="getCode"
            >
              获取验证码
            </el-button>
            <span v-show="!show" class="count">{{ count }} s</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :disabled="disabled" @click="payclick()">
        预付
      </el-button>
    </div>
  </div>
</template>
<script>
import { payAdvance } from "@/api/CustomerService";
import { mybankBalancePay } from "@/api/InternetBanking";
import { mayDecimal } from "@/utils/validate4Form.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      cashdisabled: false,
      disabled: true,
      show: true,
      count: "",
      row: {},
      form: {
        cash: "",
        orderDetailCode: "",
        payType: 4,
        balancePayType: 1,
        amount: "",
        totalAmount: "",
        mybankBalancePayDTO: {
          smsCode: ""
        }
      },
      rules: {
        cash: [
          { required: true, message: "请输入预付现金", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    setFee(row) {
      this.form.amount = "";
      this.form.totalAmount = "";
      this.form.cash = "";
      this.form.mybankBalancePayDTO.smsCode = "";
      this.row = row;
      this.form.orderDetailCode = row.code;
    },
    close() {
      this.cashdisabled = false;
      this.count = 0;
      this.disabled = true;
    },
    verifyPayee(params, backFun) {
      request({
        url: `/ntocc-tms-api/payAdvance/verifyPayee`,
        method: "get",
        params: params
      }).then(response => {
        if (response.data) {
          backFun();
        } else {
          this.$confirm("预付将使本账户汇款超额，是否继续预付操作？").then(
            _ => {
              backFun();
            }
          );
        }
      });
    },
    //预付现金
    payclick() {
      const rLoading = this.openLoading();
      this.form.amount = this.form.cash;
      const $this = this;
      payAdvance($this.form).then(response => {
        $this.show = true;
        rLoading.close();
        $this.$emit("closeWindows");
        $this.$message({
          message: response.msg,
          type: "success"
        });
        $this.cashdisabled = false;
        $this.disabled = true;
      });
    },
    //获取验证码
    getCode() {
      this.form.amount = this.form.cash;
      this.form.totalAmount = this.form.cash;
      const $this = this;
      if (this.form.totalAmount == "") {
        this.$message({
          message: "请输入预付现金",
          type: "warning"
        });
      } else {
        this.verifyPayee(this.form, function() {
          const rLoading = $this.openLoading();
          mybankBalancePay($this.form).then(response => {
            rLoading.close();
            $this.$message({
              message: response.msg,
              type: "success"
            });
            $this.disabled = false;
            $this.cashdisabled = true;
            $this.form.mybankBalancePayDTO = response.data;
            if (response.status == 0) {
              const TIME_COUNT = 60;
              if (!$this.timer) {
                $this.count = TIME_COUNT;
                $this.show = false;
                $this.timer = setInterval(() => {
                  if ($this.count > 0 && $this.count <= TIME_COUNT) {
                    $this.count--;
                  } else {
                    $this.show = true;
                    clearInterval($this.timer);
                    $this.timer = null;
                  }
                }, 1000);
              }
            }
          });
        });
      }
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  float: right;
}
.count,
.smscode {
  height: 40px;
  line-height: 40px;
  display: block;
  padding-left: 5px;
}
</style>
